import { useEffect } from "react";

const SRC = "https://player.vimeo.com/video/1242880102?badge=0&autopause=0&title=0&byline=0&portrait=0&dnt=1";
const PLAYER_JS = "https://player.vimeo.com/api/player.js";

export default function DemoVideo() {
  useEffect(() => {
    if (document.querySelector(`script[src="${PLAYER_JS}"]`)) return;
    const s = document.createElement("script");
    s.src = PLAYER_JS;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section className="px-6 pb-20" data-testid="home-demo-video">
      <div className="max-w-[960px] mx-auto text-center">
        <div className="label-mini" data-testid="demo-video-label">See it in 2 minutes</div>
        <p className="mt-3 text-base md:text-lg text-neutral-700" data-testid="demo-video-subline">
          A QuickBooks invoice lands in Xero as a bill. No one had to type anything in.
        </p>
        <div className="mt-8 rounded-xl overflow-hidden border border-neutral-200">
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              src={SRC}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              title="Lingua Franca in 2 minutes: a QuickBooks invoice becomes a Xero bill"
              data-testid="demo-video-iframe"
            />
          </div>
        </div>
        <p className="mt-4 text-sm text-neutral-700" data-testid="demo-video-no-card">
          No credit card needed. Your first 100 invoices (or 6 months) are free, then $0.25 per invoice.
        </p>
      </div>
    </section>
  );
}
